export const CDN_URL = 'https://next-idols-public.s3.us-west-2.amazonaws.com';
export const CDN_URL_M = `${CDN_URL}/202303/mobile`;

export const bodyWidth = 1440;
